import React from "react";
import handshake from "../images/handshake.png";

const HomeDonate = () => {
  return (
    <div className="text-white">
      <div className="home-donate p-32 flex items-center md:justify-center md:hidden">
        <div className="flex items-center p-6 border-2 border-white space-x-10">
          <div className="h-[353px] w-[369px]">
            <img
              src={handshake}
              alt=""
              className="h-full w-full object-cover"
            />
          </div>
          <div className="p-10 space-y-5 text-white">
            <h2>Donate</h2>
            <p className="w-[200px]">
              Let us work together as a community and keep the culture alive
            </p>
            <button className="px-10 py-4 bg-white text-black">PROCEED</button>
          </div>
        </div>
      </div>
      <div className="home-donate h-[326px] flex flex-col items-center justify-center space-y-6 text-center px-6 md-min:hidden">
        <h1 className="text-2xl">DONATE</h1>
        <p className="text-sm">
          Let us work together as a community and keep the culture alive
        </p>
        <button className="px-10 py-4 bg-white text-black">PROCEED</button>
      </div>
    </div>
  );
};

export default HomeDonate;
